// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-S6SI","type":"styles_type__3whlY","choices":"styles_choices__vkR9b"};